<template>
    <div>

        <div class="pl-4 pb-4 text-h5 font-weight-bold">
            {{ headerText }}
        </div>

        <div class="pl-4 pr-4 pt-0 pb-3" v-if="useAccountText">
            {{ useAccountText }}
        </div>

        <div class="d-flex flex-wrap pl-2 pr-2">

            <div v-if="buttonConfig.length > 0"
                 v-for="config in buttonConfig"
                 :key="config.type"
                 class="pa-2">

                <v-btn color="white-darken-1"
                       min-width="120"
                       :loading="config.loading"
                       @click="authenticationSelected(config.type)">
                    <div class="d-flex justify-start" style="width: 120px;">
                        <v-img class="mr-2"
                               max-width="18"
                               max-height="18"
                               :src="cdnBaseUrl('/img/'+ config.type + '_icon.png')"/>
                        <div>{{ config.name }}</div>
                    </div>
                </v-btn>

            </div>
        </div>

        <div class="pl-4 pr-4 pt-3 pb-3">
            {{ useEmailText }}
        </div>

        <div class="pl-2 pr-2">
            <div class="d-flex pa-2 justify-start">
                <v-btn class="justify-end"
                       color="white-darken-1"
                       :loading="emailButtonLoading"
                       @click="authenticationSelected('email')">
                    <v-icon left>mdi-at</v-icon>
                    EMAIL
                </v-btn>
            </div>
        </div>
    </div>
</template>

<script>

import MarkdownViewer from "@/components/UI/MarkdownViewer.vue";

export default {

    name: "SocialMediaSelector",

    components: {MarkdownViewer},

    props: {
        types: {
            type: Array,
            required: false,
            default: () => []
        },

        headerText: {
            type: String | null,
            required: false,
            default: null
        },

        useAccountText: {
            type: String | null,
            required: false,
            default: null
        },

        useEmailText: {
            type: String,
            required: false,
            default: 'Alternatively you may use your sign-on using email'
        },

        emailButtonLoader: {
            type: Boolean,
            required: false,
            default: true,
        }
    },

    data() {
        return {
            buttonConfig: [],
            emailButtonLoading: false,
        }
    },

    watch: {
        types() {
            this.createButtonConfig();
        }
    },

    mounted() {

        if (!this.types) {
            return;
        }

        this.createButtonConfig();
    },

    methods: {

        createButtonConfig() {

            this.buttonConfig = this.types.map(type => {

                let name = type;

                if (type === 'linkedin-openid') {
                    name = type.replace('-openid', '');
                }

                if (type === 'x') {
                    name = 'Twitter'
                }

                return {
                    name: name,
                    type: type,
                    loading: false
                }
            });

            // This can be removed when the feature flag is removed
            this.buttonConfig = this.buttonConfig.filter (config => config.type !== 'x' && !this.hasPermission('social_x_auth'));
        },

        authenticationSelected(type) {

            if (type === 'email' && this.emailButtonLoader) {
                this.emailButtonLoading = true;
            } else {
                let found = this.buttonConfig.find(config => config.type === type);
                if (found) {
                    found.loading = true;
                }
            }

            this.$emit('change', type);
        }
    }
}

</script>
